import {
  Button, CardActions, CardContent, Divider,
  Grid,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PersonIcon from "@material-ui/icons/Person";
import BlueStarIcon from '@material-ui/icons/Stars';
import React from "react";
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
  heading: {
    lineHeight: "150%",
    height: "50px",
    fontWeight: "bold",
    fontSize: "19px",
    color: "#37281F",
    textAlign: "center",
    [theme.breakpoints.only("xs")]: {
      fontWeight: "600",
      fontSize: "16.3767px",
      lineHeight: "150%",
      textAlign: "center",
      color: "#37281F"
    },
  },
  expertName: {
    fontWeight: "bold",
    fontSize: "20px",
    color: "rgba(0, 0, 0, 0.87)",
  },
  removeCustomMargin: {
    [theme.breakpoints.down("sm")]: {
      "&.MuiGrid-root.MuiGrid-item": {
        margin: "0 !important",
      },
    },
  },
  userIcon: {
    width: "100% !important",
    marginLeft: "10px",
    marginRight: "10px",
    [theme.breakpoints.down("md")]: {
      padding: "10px !important",
    },
  },
  BlueStarIcon: {
    height: '30px !important',
    width: '30px !important',
    marginBottom: '-9px',
    marginLeft: '5px',
  },
  workIcon: {
    width: "30px !important",
    marginLeft: "17.5px",
    marginRight: "17.5px",
  },
  expertWork: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "rgba(0, 0, 0, 0.87)",
    [theme.breakpoints.down("sm")]: {
      textAlign: "right",
    },
  },
  price: {
    fontSize: "17px",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.87)",
  },
  row: { display: "flex", alignItems: "center" },
  end: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      flexDirection: "column",
    },
  },
  productCardContent: {
    overflow: "hidden",
    padding: "0",
    marginBottom: "25px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "400px",
  },
  expertProfileDesc: {
    overflow: "auto",
    height: "160px",
    width: "calc(100% + 12px)",
    padding: "5px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      height: "auto",
    },
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&:hover::-webkit-scrollbar-thumb': {
      borderRadius: '5px',
      background: '#707070',
    },
    '&:hover::-webkit-scrollbar-track': {
      borderRadius: '5px',
      boxShadow: 'inset 0 0 3px grey',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#8b8b8b',
    },
  },
  expertProfileSection: {
    overflow: "auto",
    height: "175px",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      height: "100%",
      textAlign: "center",
    },
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&:hover::-webkit-scrollbar-thumb': {
      borderRadius: '5px',
      background: '#707070',
    },
    '&:hover::-webkit-scrollbar-track': {
      borderRadius: '5px',
      boxShadow: 'inset 0 0 3px grey',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#8b8b8b',
    },
  },
  expertInfoTitle: {
    textDecoration: "underline",
  },
  expertTagVal: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.87)",
    // color: "#9b9595",
    paddingLeft: "12px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
    },
  },
  mobileDesign: {
    [theme.breakpoints.down("sm")]: {
      flexWrap: "nowrap",
      justifyContent: "start",
    },
  },
  description: {
    color: "rgba(0, 0, 0, 0.87)",
    fontWeight: "bold"
  },
  userIconPosition: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
  }
}));

const useStyledToolTip = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    color: '#fff',
    fontSize: '14px',
  },
}));

const ExpertCardContent = ({ item, onExpertClick, onBuyNowClick }) => {
  const styledToolTip = useStyledToolTip();
  const classes = useStyles();
  return (
    <>
      <Typography
        gutterBottom
        variant="h5"
        component="h2"
        className={classes.heading}
      >
        {item.trackName}
        {item.expertInfo.volunteer &&
          <Tooltip title={`${item.expertInfo.name} is a volunteer`} arrow placement="top" classes={styledToolTip}>
            <BlueStarIcon color="primary" className={classes.BlueStarIcon} />
          </Tooltip>}
      </Typography>
      <Divider />

      <CardContent>
        <Grid container direction="column">
          <Grid item lg={12}>
            <Grid
              container
              spacing={3}
              className={classes.expertProfileSection}
            >
              <Grid item lg={3} className={classes.userIconPosition}>
                {item.expertInfo.photoURL == "" ?
                  <PersonIcon className={classes.userIcon} /> :
                  <img className={classes.userIcon} src={item.expertInfo.photoURL} alt="" />
                }
              </Grid>
              <Grid item lg={9} className={classes.removeCustomMargin}>
                <Grid container direction="column">
                  <Grid item lg={12}>
                    <Typography
                      gutterBottom
                      variant={"h5"}
                      onClick={() => onExpertClick(item)}
                      className={classes.expertName}
                    >
                      {item.expertInfo.name}
                    </Typography>
                  </Grid>

                  {item?.tags.map((tag) => (
                    <Grid
                      item
                      lg={12}
                      key={`tag-${tag.key}`}
                      className={classes.removeCustomMargin}
                    >
                      <Grid
                        container
                        direction="row"
                        className={classes.mobileDesign}
                      >
                        <Grid item lg={3} xs={4} className={classes.removeCustomMargin}>
                          <Typography
                            gutterBottom
                            variant={"h5"}
                            className={classes.expertWork}
                          >
                            {tag.key}:
                          </Typography>
                        </Grid>

                        <Grid item lg={8} xs={8} className={classes.removeCustomMargin}>
                          <Typography
                            gutterBottom
                            variant={"h5"}
                            className={classes.expertTagVal}
                          >
                            {tag.value.join(", ")}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>

      <Divider />

      <CardContent>
        <Grid container direction="row" className={classes.expertProfileDesc}>
          <Grid item lg={12} className={classes.expertInfoTitle}>
            <Typography
              gutterBottom
              variant={"h5"}
              className={classes.expertWork}
            >
              About Expert
            </Typography>
          </Grid>
          <Grid item lg={12}>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.description}
              paragraph
              dangerouslySetInnerHTML={{ __html: item.expertInfo.profile }}
            />
          </Grid>
        </Grid>
      </CardContent>

      <Grid
        container
        direction="row"
        className={classes.end}
        spacing={2}
        alignItems="center"
      >
        <Grid item>
          <Typography
            variant="body2"
            color="textSecondary"
            gutterBottom={true}
            className={classes.price}
          >
            {`$${(item.price / 100).toString()}/Hr/Session`}
          </Typography>
        </Grid>
        <Grid item>
          <CardActions>
            <Button
              component="button"
              variant="contained"
              disableRipple
              onClick={() => onBuyNowClick(item)}
              className={"successBtn"}
            >
              Buy Now & Schedule
            </Button>
          </CardActions>
        </Grid>
      </Grid>
    </>
  );
};

export default ExpertCardContent;
